import { useSyncExternalStore } from 'react'
import type { MetroMapState, Theme } from './metroMapStore'
import { useMetroMapStore } from './useMetroMapStore'

/**
 * The EFFECTIVE render theme — the single signal that decides whether
 * the map draws the dark MMTG geometry (TASK-412 M, option i): Night
 * Tube forces dark regardless of the OS preference; otherwise the
 * system theme rules.
 *
 * 2026-07 color contract: every line-colored UI surface (pills, badges,
 * rails, suggester dots, station cards) MUST select its palette with
 * THIS signal — the same one `MetroMapCanvas` renders with — or
 * night-tube produces a dark map with light-palette pills. Do not read
 * `state.theme` directly for color selection.
 */
export function effectiveTheme(state: Pick<MetroMapState, 'theme' | 'currentMode'>): Theme {
  return state.currentMode === 'night' ? 'dark' : state.theme
}

/** {@link effectiveTheme} of the current store state, subscription-backed. */
export function useEffectiveTheme(): Theme {
  const store = useMetroMapStore()
  return useSyncExternalStore(store.subscribe, () => effectiveTheme(store.getState()))
}
